import { useParams, useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { ArrowLeft } from "lucide-react";
import { api } from "@/api";
import { useAuth } from "@/auth";
import { C, STAGE_COLORS } from "@/theme";
import { canRecordStage, stageLabel } from "@/pathway";
import { Card, LoadingState, ErrorState } from "@/ui";
import { PathwayTimeline } from "@/shared";
import { PageHeader } from "@/components/AppShell";

export default function Pathway() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { user } = useAuth();
  const q = useQuery({ queryKey: ["rider", id], queryFn: () => api.get(`/riders/${id}`), enabled: !!id });
  const rider = q.data;

  return (
    <div>
      <button onClick={() => navigate(-1)} style={{ color: C.muted }} className="flex items-center gap-1.5 text-sm font-semibold mb-3"><ArrowLeft size={16} />Back</button>
      <PageHeader title="Training Pathway" subtitle={rider?.name} />
      {q.isLoading ? <LoadingState /> : q.isError || !rider ? <ErrorState onRetry={q.refetch} /> : (
        <div className="flex flex-col gap-4 max-w-2xl">
          <Card>
            <div className="flex items-center gap-3 flex-wrap"><span style={{ background: (STAGE_COLORS[rider.pathway_status ?? ""] ?? C.brandPrimary) + "22", color: STAGE_COLORS[rider.pathway_status ?? ""] ?? C.brandPrimary }} className="px-3 py-1.5 rounded-full text-sm font-extrabold">{stageLabel(rider.pathway_status) || "—"}</span>{rider.pathway_status !== "Disabled" && rider.pathway_status !== "Approved for Test" ? <span style={{ color: C.muted }} className="text-[13px] font-semibold">Run {rider.next_run_number} of 15 next</span> : null}</div>
          </Card>
          <Card>
            <PathwayTimeline runs={rider.runs ?? []} nextRunNumber={rider.next_run_number ?? 1} pathwayStatus={rider.pathway_status ?? "Assessment"} variant="full" extraUnlocked={!!rider.extra_runs_unlocked}
              onPressRun={(run) => canRecordStage(user?.role, run.stage ?? "", user?.is_assessor) ? navigate(`/run-form?id=${run.id}`) : navigate(`/run/${run.id}`)} />
          </Card>
        </div>
      )}
    </div>
  );
}
